var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 0.75C22.4225 0.75 25.5 3.875 25.5 8.25C25.5 17 16.125 22 13 23.875C9.875 22 0.5 17 0.5 8.25C0.5 3.875 3.625 0.75 7.375 0.75C9.7 0.75 11.75 2 13 3.25C14.25 2 16.3 0.75 18.625 0.75ZM14.1675 20.255C15.2688 19.56 16.2625 18.8687 17.1925 18.1287C20.9188 15.1663 23 11.9288 23 8.25C23 5.3 21.0788 3.25 18.625 3.25C17.28 3.25 15.825 3.9625 14.7675 5.0175L13 6.785L11.2325 5.0175C10.175 3.9625 8.72 3.25 7.375 3.25C4.95 3.25 3 5.32 3 8.25C3 11.93 5.0825 15.1663 8.80625 18.1287C9.7375 18.8687 10.7312 19.56 11.8325 20.2537C12.2063 20.49 12.5763 20.7162 13 20.9688C13.4237 20.7162 13.7937 20.49 14.1675 20.255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d0aa4b162cfbba743b86a695c0af3a44.svg";
export { ForwardRef as ReactComponent };